/**
 * `set-party-region` — FR-09, NFR-07, CR-01. R-87-1 (amended) / D-87-10
 * (Gerry, 14 Sep 2026) · CLM-87.
 *
 * The admin override on a client's region. Verification sets `party.region`
 * once (the first verified counterparty country, `WHERE region IS NULL` —
 * D-87-9); an admin may place a client the table could not, or move one that
 * verification placed wrongly. One statement, no `region IS NULL` guard (an
 * override overrides) and no scope predicate (admin is all-scope, and `party`
 * has no `root_contract_key` — the `updateClmPartyDisplayNameQuery` precedent);
 * `tg_party_audit` writes the one audit row (rule 7). `region: null` clears
 * both columns and re-arms the first-verified rule.
 *
 * Gate `party:set_region` — admin only. Legal holds `party:manage_alias` and
 * must not re-region a client.
 */
import { z } from 'zod';
import { RegionSchema, RegionSourceSchema } from '../domain/region.js';
import { PartyKeySchema } from '../primitives.js';
import { AuditReceiptSchema } from '../provenance.js';
export const SetPartyRegionRequestSchema = z
    .object({
    party_key: PartyKeySchema,
    /** One of the four regions, or null = Unassigned (clears `region_source` too). */
    region: RegionSchema.nullable(),
    note: z.string().min(1).max(500).optional(),
})
    .strict();
export const SetPartyRegionResponseSchema = z
    .object({
    party_key: PartyKeySchema,
    region: RegionSchema.nullable(),
    /** `admin` after a set; null after a clear. */
    region_source: RegionSourceSchema.nullable(),
    /** The `tg_party_audit` row of the UPDATE — the NFR-07 receipt. */
    audit: AuditReceiptSchema,
})
    .strict();
//# sourceMappingURL=set-party-region.js.map